import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { logsPaths } from './paths';

const { Logs } = lazyImport(() => import('../views/logs'), 'Logs');
const { LogMessage } = lazyImport(() => import('../views/logMessage'), 'LogMessage');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const logsRoutes: RouteObject[] = [
  {
    path: logsPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <Logs /> },
      { path: logsPaths.logMessage.relative, element: <LogMessage /> },
    ],
  },
];
